import { hasInvoiceEdits } from "../../../assets/reusableComponents/invoiceEdits";
import "../../../assets/reusableComponents/InvoiceEditHighlight.scss";
import React, { useEffect, useState, useContext } from "react";

// Import CSS
import "./InvoicesPendingTable.scss";
import PaymentModal from "./PaymentModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { listInvoicesUnpaid } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";

const InvoicePendingTable = () => {
  const mockInvoices = [
    {
      invoice_id: "001",
      payment_status: "unpaid",
      due_date: "2023-09-15",
      rent_invoice: 5000,
      water_invoice: 300,
      garbage_charge: 100,
      service_charge: 200,
      late_fee: 50,
      arrears: 500,
    },
    {
      invoice_id: "002",
      payment_status: "unpaid",
      due_date: "2023-10-01",
      rent_invoice: 6000,
      water_invoice: 400,
      garbage_charge: 150,
      service_charge: 250,
      late_fee: 0,
      arrears: 200,
    },
    {
      invoice_id: "003",
      payment_status: "unpaid",
      due_date: "2023-11-05",
      rent_invoice: 7000,
      water_invoice: 500,
      garbage_charge: 200,
      service_charge: 300,
      late_fee: 100,
      arrears: 0,
    },
    {
      invoice_id: "004",
      payment_status: "unpaid",
      due_date: "2023-12-01",
      rent_invoice: 8000,
      water_invoice: 600,
      garbage_charge: 250,
      service_charge: 350,
      late_fee: 100,
      arrears: 0,
    },
  ];

  //context
  const { rolesAssigned, selectedDate, monthNames } = useContext(MyContext);

  //data fetched
  const dispatch = useDispatch();
  const {
    user,
    unpaidinvoices: invoicesGotten,
    profile,
    tenants: tenantsGotten,
  } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  useEffect(() => {
    console.log("CAPITAL LETERS", selectedDate);

    dispatch(listInvoicesUnpaid({ property_id, selectedMonth: monthNames.indexOf(selectedDate?.month) + 1, selectedYear: selectedDate?.year })).then((res) => {
      console.log("invoices response", res);
    });
  }, [property_id, selectedDate?.month, selectedDate?.year]);

  const [invoicesReceived, setInvoicesReceived] = useState([]);

  // Simulate data fetching with useEffect
  useEffect(() => {
    console.log("invoices gotten", invoicesGotten);
    setInvoicesReceived(Array.isArray(invoicesGotten) ? invoicesGotten : invoicesGotten?.unpaidInvoices || []);
  }, [invoicesGotten]);

  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    setInvoices(transformInvoices(invoicesReceived));
  }, [invoicesReceived]);

  const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);
  const [visibleInvoicesCount, setVisibleInvoicesCount] = useState(3); // Initially show 3 invoices

  const toggleExpand = (invoiceId) => {
    setExpandedInvoiceId(expandedInvoiceId === invoiceId ? null : invoiceId);
  };

  const showMoreInvoices = () => {
    setVisibleInvoicesCount((prevCount) => prevCount + 3);
  };

  const hideAllInvoices = () => {
    setVisibleInvoicesCount(3);
  };

  //modal
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  const [defaultValues, setDefaultValues] = useState({});
  useEffect(() => {
    //check if default values are set
    if (Object.keys(defaultValues).length > 0) {
      console.log("Default values:", defaultValues);
      setIsOpen(true); // Open the modal
    }
  }, [defaultValues]);

  const handlePayment = (invoiceId) => {
    // Handle the payment logic here
    setDefaultValues({}); // Clear the default values
    //function to find the invoice
    const invoice = invoices.find((invoice) => invoice.id === invoiceId);
    //set the default values
    setDefaultValues({
      rent: invoice.rent?.toString() || "0",
      water: invoice.water?.toString() || "0",
      arrears: invoice.arrears?.toString() || "0",
      serviceCharge: invoice.serviceCharge?.toString() || "0",
      unpaidDeposit: invoice.unpaidDeposit?.toString() || "0",
      garbage: invoice.garbage?.toString() || 0,
      paymentMethod: "M-Pesa",
    });
    console.log(`Payment for invoice ${invoiceId}`);
  };
  return (
    <div className="invoices-pending-container">
      <table className="invoice-pending-table">
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Status</th>
            <th>Due Date</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoices.slice(0, visibleInvoicesCount).map((invoice) => (
            <React.Fragment key={invoice.id}>
              <tr
                onClick={() => toggleExpand(invoice.id)}
                className={`table-row ${hasInvoiceEdits(invoice) ? "invoice-row-edited" : ""}`}
                title={hasInvoiceEdits(invoice) ? "Manually changed" : undefined}
              >
                <td>{invoice.id}</td>
                <td>{invoice.status}</td>
                <td>{invoice.dueDate}</td>
                <td>{invoice.totalAmount}</td>
              </tr>
              {expandedInvoiceId === invoice.id && (
                <tr>
                  <td colSpan="4">
                    <div className={`expanded-space ${hasInvoiceEdits(invoice) ? "invoice-row-edited" : ""}`}>
                      <div>
                        <div className="title">Invoice Details</div>
                        <div className="expanded-data">
                          <div className="head">Invoice ID:</div>
                          <div className="details">{invoice.id}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Rent:</div>
                          <div className="details">{invoice.rent}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Water:</div>
                          <div className="details">{invoice.water}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Garbage:</div>
                          <div className="details">{invoice.garbage}</div>
                        </div>
                        {[ ["service_charge", "Service Fee"], ["late_fee", "Late Fee"], ["arrears", "Arrears"], ["unpaid_deposit", "Unpaid Deposit"] ].map(([field, label]) => (
                          <div className="expanded-data" key={field}>
                            <div className="head">{label}:</div>
                            <div className="details">{invoice[field]}</div>
                          </div>
                        ))}
                        <div className={`expanded-data final`}>
                          <div className="head">Total Payable Amount:</div>
                          <div className="total">{invoice.totalPayable}</div>
                        </div>

                        {rolesAssigned?.makePayments && (
                          <>
                            <button onClick={() => handlePayment(invoice.id)}>
                              Make Payment
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="buttons-container">
        {visibleInvoicesCount < invoices.length && (
          <button
            onClick={showMoreInvoices}
            className="show-more-and-hide-button"
          >
            Show More
          </button>
        )}
        {visibleInvoicesCount > 3 && (
          <button
            onClick={hideAllInvoices}
            className="show-more-and-hide-button"
          >
            Hide All
          </button>
        )}
      </div>

      <PaymentModal
        isOpen={isOpen}
        closeModal={closeModal}
        defaultValues={defaultValues} // Set default values here
        fieldsToShow={[
          "rent",
          "arrears",
          "water",
          "serviceCharge",
          "unpaidDeposit",
          "garbage",
        ]} // Specify which fields to show
      />
    </div>
  );
};
function transformInvoices(invoices) {
  console.log("received these invoices", invoices);

  return invoices
    .filter((invoice) => invoice.payment_status !== "fully_paid") // Filter out fully paid invoices
    .map((invoice) => {
      // Calculate the total amount by summing up the individual charges
      const totalAmount = (
        parseFloat(invoice.rent || 0) +
        parseFloat((invoice.waters ?? invoice.water) || 0) +
        parseFloat(invoice.garbage || 0) +
        parseFloat((invoice.service_charge ?? invoice.service_fee) || 0) +
        parseFloat(invoice.late_fee || 0) +
        parseFloat(invoice.unpaid_deposit || 0) + parseFloat(invoice.arrears || 0)
      ).toFixed(2);

      // Determine the status
      const status =
        invoice.payment_status === "fully_paid" ? "Paid" : "Unpaid";

      // Calculate total payable amount
      const totalPayable = totalAmount; // Adjust if you need to add any extra charges

      return {
        id: `INV${String(invoice.invoice_id || invoice._id || "").padStart(3, "0")}`, // Format ID with leading zeros
        status: status,
        dueDate: invoice.due_date
          ? new Date(invoice.due_date).toISOString().split("T")[0]
          : "no due date", // Return "no due date" if due_date is null or undefined
        totalAmount: totalAmount,
        isEdited: invoice.isEdited,
        service_charge: invoice.service_charge ?? invoice.service_fee ?? 0,
        late_fee: invoice.late_fee ?? 0,
        arrears: invoice.arrears ?? 0,
        unpaid_deposit: invoice.unpaid_deposit ?? 0,
        rent: invoice.rent || "0",
        water: (invoice.waters ?? invoice.water) || "0",
        garbage: invoice.garbage || "0",
        otherCharges: (
          parseFloat((invoice.service_charge ?? invoice.service_fee) || 0) +
          parseFloat(invoice.late_fee || 0) +
          parseFloat(invoice.unpaid_deposit || 0)
        ).toFixed(2),
        totalPayable: totalPayable,
      };
    });
}

export default InvoicePendingTable;
